<template>
  <div class="header-wrapper">
    <VueHeadline weightLevel="3" level="3" color="grey-40" class="headline">
      {{ headline }}</VueHeadline
    >
    <div level="20"></div>

    <VueText sizeLevel="4" weightLevel="2" class="text" color="grey-30">{{ text }}</VueText>
  </div>
</template>

<script>
import VueText from '@/components/shared/VueText/VueText.vue';
import VueHeadline from '@/components/shared/VueHeadline/VueHeadline.vue';

export default {
  name: 'Header',
  components: { VueText, VueHeadline },
  props: {
    text: {
      type: String,
    },
    headline: {
      type: String,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.header-wrapper {
  background-color: palette-color-level('grey', '10');
  padding: palette-space-level('45') palette-space-level('20');
}

.headline {
  width: 100%;
  line-height: 1.22;
}

.text {
  line-height: 1.57;
  padding-top: palette-space-level('5');
}
</style>
